export default "__VITE_PUBLIC_ASSET__cfe925c9__"